import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNImportTransactionFilesProxy, UiPxTransactionFilesModule } from '@wlp/ui-px-import-files';

let TransactionFileService = class TransactionFileService {
    constructor(speNImportFiles) {
        this.speNImportFiles = speNImportFiles;
    }
    getImportFiles(userProfileInfo, filter) {
        return this.speNImportFiles.getImportFiles(userProfileInfo, filter);
    }
    uploadFile(data, uuidAccountPayment) {
        return this.speNImportFiles.uploadFile(data, uuidAccountPayment);
    }
    translateFile(data, uuidAccountPayment) {
        return this.speNImportFiles.translateFile(data, uuidAccountPayment);
    }
    getDownloadLayoutFileCsv(fileType) {
        return this.speNImportFiles.getDownloadLayoutFileCsv(fileType);
    }
    getDownloadResumeFile(uuidTransactionFileId, type) {
        return this.speNImportFiles.getDownloadResumeFile(uuidTransactionFileId, type);
    }
};
TransactionFileService.ctorParameters = () => [
    { type: SpeNImportTransactionFilesProxy }
];
TransactionFileService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TransactionFileService_Factory() { return new TransactionFileService(ɵɵinject(SpeNImportTransactionFilesProxy)); }, token: TransactionFileService, providedIn: "root" });
TransactionFileService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], TransactionFileService);

let UiBsTransactionFileModule = class UiBsTransactionFileModule {
};
UiBsTransactionFileModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            TransactionFileService
        ],
        imports: [CommonModule, FormsModule, IonicModule, UiBsUtilModule, UiPxTransactionFilesModule],
        exports: [RxReactiveFormsModule],
    })
], UiBsTransactionFileModule);

/*
 * Public API Surface of ui-bs-pix
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TransactionFileService, UiBsTransactionFileModule };
//# sourceMappingURL=wlp-ui-bs-import-files.js.map
